import { ScanButtonType } from '@src/components/ai-cohorts/types';
import { Button, Divider, Tag } from 'antd';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { ToggleButton as CommonToggleButton } from '@src/components/common/Utils/Buttons';

export const HeaderPanelWrapper = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 3px solid rgb(0 0 0 / 6%);
`;

export const HeaderWrapper = styled.div`
  padding: 50px 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: #fff;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
`;

export const LeftWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 20px;
  order: 1;
  ${breakpoint('tablet')`
        width: 50%;
    `};

  ${breakpoint('desktop')`
        width: 50%;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const RightWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  order: 1;
  flex-wrap: wrap;
  align-items: flex-end;
  align-items: center;
  gap: 5px;
  ${breakpoint('tablet')`
        width: 50%;
    `};

  ${breakpoint('desktop')`
        width: 50%;
    `};

  ${breakpoint('mobile')`
        width: 100%;
    `};
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  letter-spacing: 0;
  text-align: left;
  color: #000;
`;

export const StyledDivider = styled(Divider)`
  height: 30px;
`;

export const StyledButton = styled(Button)`
  margin-right: 3px;
`;

export const DatePickerWrapper = styled.div`
  border-color: #dadada;
  border-radius: 6px;
  border-left: solid 10px #0f93f54d;

  .ant-menu-vertical {
    margin-top: 25px;
  }

  .ai-alerts-date-picker {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`;

export const StyledTag = styled(Tag)`
  height: 32px;
  margin-left: 10px;
  position: relative;
  padding-right: 25px;
  line-height: 2.5;

  .anticon {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
  }
`;

export const IconWrap = styled.div`
  font-size: 1.25em;
  line-height: 0;
  margin-right: 3px;
  display: inline-block;
  fill: #0046ff;
  vertical-align: -0.125em;
`;

export const ScanIconWrap = styled.div`
  display: inline-block;
  font-size: 14px;
  margin-right: 4px;
  vertical-align: middle;
`;

export const CombinationText = styled.p<ScanButtonType>`
  display: flex;
  align-items: center;
  column-gap: 5px;
  margin: 0;
  color: ${({ isLink }) => (isLink ? '#0046FF' : '#4A4A4A')};
  font-weight: 500;
  font-size: 15.4px;
  line-height: 21px;
  cursor: ${({ isLoading, isError, isLink }) =>
    isLoading ? 'progress' : isError ? 'not-allowed' : isLink ? 'pointer' : 'inherit'};
`;

export const AICohortText = styled.div`
  margin-left: 18px;
`;

export const ToggleButton = styled(CommonToggleButton)`
  flex: none;
`;
